<h5 *ngIf="isHeadingAvailable">{{heading}}</h5>

<ng-container [ngSwitch]="listTag">
    <div *ngSwitchCase="'ul'">
        <ul>
            <div *ngFor="let listitem of listItems; let i= index">
                <li [ngClass]="cssClass" [innerHTML]="listitem">{{listitem}}</li>
            </div>
        </ul>
    </div>
    <div *ngSwitchCase="'ol'">
        <ol [type]="liType||'1'">
            <div *ngFor="let listitem of listItems; let i= index">
                <li [ngClass]="cssClass" [innerHTML]="listitem" >{{listitem}}</li>
            </div>
        </ol>
    </div>
</ng-container>